import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import CountChars from 'umg-ember-backend/components/ui/count-chars';

export default class Seo extends Component {
  get seoTitle() {
    let model = this.args.form.model;

    return model.seoTitle ?? model.headline ?? model.displayHeadline;
  }

  <template>
    <@form.fieldset @titleKey='seo' @isClosed={{@isClosed}} as |fieldset|>
      <fieldset.field @property='seoTitle' @placeholder={{this.seoTitle}} />
      <CountChars @min={{50}} @max={{60}} @text={{this.seoTitle}} />
      <fieldset.field @property='seoDescription' />
      <CountChars
        @min={{100}}
        @max={{130}}
        @text={{@form.model.seoDescription}}
      />
      <fieldset.field
        @filters={{hash assetFolderId='106'}}
        @property='seoImage'
        @options={{hash allowedFolder='100'}}
        @type='belongs-to'
        as |record|
      >
        <AssetPreview @asset={{record}} />
      </fieldset.field>
      {{yield fieldset}}
    </@form.fieldset>
  </template>
}
